import { DocumentType } from '@synergy/models';

export const getUrlSegment = (documentType: DocumentType): string => {
    switch (documentType) {
        case DocumentType.Credit: {
            return 'invoices';
        }
        case DocumentType.Inquiry: {
            return 'inquiries';
        }
        case DocumentType.Offer: {
            return 'offers';
        }
        case DocumentType.PurchaseOrder: {
            return 'purchase-orders';
        }
        case DocumentType.SalesOrder: {
            return 'sales-orders';
        }
        case DocumentType.Demand: {
            return 'demands';
        }
        case DocumentType.DemandAccount: {
            return 'demand-accounts';
        }
        case DocumentType.Invoice: {
            return 'invoices';
        }
        case DocumentType.Contact: {
            return 'contacts';
        }
        case DocumentType.Supplier: {
            return 'accounts';
        }
        case DocumentType.Customer: {
            return 'accounts';
        }
        case DocumentType.Product: {
            return 'products';
        }
        default:
            throw Error('Invalid document type');
    }
};
